import { NavigationPathsEnum } from "@utilities/enums";
import { useNavigation, useUser } from "@utilities/hooks";
import { useCallback, useEffect, useMemo, useState } from "react"
import { useSearchParams } from "react-router-dom";

export const useControllers = () => {

    const { navigateTo } = useNavigation();
    const [params] = useSearchParams();
    const { 
        verifyEmailError, temporaryToken,
        emailVerifyisSuccess,
        setTemporaryToken, onVerifyEmail,
        onResendMailOtp,
    } = useUser();

    const navParams = useMemo(() => ({
        token: params.get('token'),
        email: params.get('email'),
        otp: params.get('otp'),
    }), [params]);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(()=> {
        (async()=> {
            if(navParams.token){
                setTemporaryToken(navParams.token);
            }
            if(navParams.email && navParams.otp){
                setIsLoading(true);
                await onVerifyEmail(navParams.email, navParams.otp);
                setIsLoading(false);
            }
        })();
    }, [navParams]);

    useEffect(()=> {
        if(emailVerifyisSuccess){
            navigateTo(NavigationPathsEnum.CREATE_PASSWORD)
        }
    }, [emailVerifyisSuccess]);

    const handleOtpResend = useCallback(async()=> {
        if(temporaryToken){
            setIsLoading(true);
            await onResendMailOtp(temporaryToken)
            setIsLoading(false);
        }
    }, [temporaryToken, onResendMailOtp]);

    return {
        isLoading,
        verifyEmailError,
        handleOtpResend,
    }
}
